<template>
  <div>
    <div
      class="modal fade"
      :id="`shareModal${item.id}`"
      tabindex="-1"
      role="dialog"
      aria-labelledby="shareModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="shareModalLabel"
            >
              Share
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="onCloseModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ShareNetwork
              network="facebook"
              :url="url"
              :title="name"
              hashtags="eastflix,vite"
            >
              <social-icon
                type="facebook"
                color="#4267B2"
              />
            </ShareNetwork>
            <ShareNetwork
              network="whatsapp"
              :url="url"
              :title="name"
              hashtags="eastflix,vite"
            >
              <social-icon
                type="whatsapp"
                color="#25D366"
              />
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              :url="url"
              :title="name"
              hashtags="eastflix,vite"
            >
              <social-icon
                type="twitter"
                color="#1DA1F2"
              />
            </ShareNetwork>
          </div>

          <div class="modal-footer">
            <UrlCopy :url="url" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialIcon from './SocialIcon';
import UrlCopy from './url-copy';

export default {
  name: 'share-modal',
  components: { SocialIcon, UrlCopy },
  props: ['item', 'name', 'has_episode', 'is_flix','single'],

  computed: {
    url() {
      if (this.is_flix) {
        var url_router = this.single ? 'single-item' : 'details';
        if (this.item.slug === null)
          return `${window.location.origin}/flix/${url_router}/${this.item.id}`;
        return `${window.location.origin}/flix/${url_router}/${this.item.slug}`;
      } else {
        if (this.has_episode) {
          var item =
            this?.item?.item_slug !== null
              ? this.item.item_slug
              : this.item.item_id;
          var episode_id =
            this.item?.episode_slug !== null
              ? this.item.episode_slug
              : this.item.id;
          return `${window.location.origin}/watch-video/${item}/${episode_id}`;
        } else {
          var item = this.item?.slug !== null ? this.item.slug : this.item.id;
          return `${window.location.origin}/watch-video/${item}`;
        }
      }
    },

    onCloseModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
<style scoped>
.modal-content {
  background-color: var(--color-grayish-white);
  border-radius: 20px;
}

@media screen and (max-width: 480px) {
  a.share-network-facebook a,
  a.share-network-whatsapp a,
  a.share-network-twitter a {
    padding: 5px 25px !important;
    font-size: 0rem !important;
  }
}

.modal-header {
  border-bottom: 1px solid transparent;
}

.close {
  color: #aeb2bd;
  background-color: transparent;
}

.close span {
  font-size: 30px;
}
</style>
